<template>
  <v-row>
    <v-col cols="12" sm="6">
      <SimpleDatePicker
        label="Begin Date"
        :value="dateBegin"
        :isRequired="true"
        :clearable="true"
        :hideDetails="true"
        @selected-date-change="(newValue) => dateBegin = newValue"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <SimpleDatePicker
        label="End Date"
        :value="dateEnd"
        :isRequired="true"
        :clearable="true"
        :hideDetails="true"
        :minDate="minimumEndDate"
        :minDateEnable="Boolean(dateBegin)"
        @selected-date-change="(newValue) => dateEnd = newValue"
      />
    </v-col>
  </v-row>
</template>

<script>
import { SimpleDatePicker } from '@/components/shared/datePickers'
import { mapFields } from '@/vueHelpers/vuex'

export default {
  components: {
    SimpleDatePicker
  },
  computed: {
    ...mapFields('payrollReportFilters', ['dateBegin', 'dateEnd']),
    minimumEndDate () {
      if (!this.dateBegin) return null
      return String(this.dateBegin).split('T')[0]
    }
  }
}
</script>
